import * as React from "react";
import {cs} from "@Common/react/chain-services";
import {cx} from "emotion";

import "./order-info.scss";

import {isApiTrue}        from "@Common/logic/is-api-true";
import {isPickPack,
          isUyoMPB}       from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {bindInput}        from "@Common/react/bind-input";
import {consumeContext}   from "@Common/react/context";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {chain}            from "@Common/utils/fs";

import {DivCollapser1} from "@Xpresso/routes/common/components/div-collapser-1/div-collapser-1";

export const OrderInfo = ({className, state, templateOptions, oia, variationsStock}) => templateOptions && (
    <div className={cx("order-info-9jd", className)}>
        <div className="header">
            <div className="title">
                Order Name {InformationBadge({getTooltip: orderNameInfo})}
            </div>
        </div>

        <div className={state.value ? "order-name" : "order-name empty"}>
            <input {...{
                ...bindInput({
                    ...state,
                }),
                "xd-qa-type": "textbox",
                "xd-qa-name": "Order Name",
            }}/>
            <div className="search-controls">
                {state.value && (
                    <div
                        className="clear"
                        onClick={() => state.onChange(null)}
                    >
                        <i
                            className="fa fa-times-circle"
                            xd-qa-type="icon"
                            xd-qa-name="close"
                        />
                    </div>
                )}
            </div>
        </div>

        {oia && (
            <div className="template-name">
                {templateOptions.name}
            </div>
        )}

        {Description({description:templateOptions?.description})}

        {FinishedSize({product:templateOptions?.product})}

        {isUyoMPB(templateOptions) && uyoHelperSection()}
        {templateOptions && isPickPack(templateOptions) && <>
            {templateOptions?.availableStock > 0 ? (
                AvailableStock({
                    stock: templateOptions?.availableStock,
                })
            ) : templateOptions?.availableStock === 0 && isApiTrue(templateOptions.options?.find(opt => opt.devKey == "allow_back_order")?.value) && (
                AvailableStock({
                    stock: "Out of stock. This product is available for backorder.",
                })
            )}
            {ProductionTime({
                time: productionTime({templateOptions}),
            })}
        </>}

        {variationsStock?.show && VariationsAvailableStock(variationsStock)}
    </div>
);

const orderNameInfo = () => "Choose a name to remember this order by";

const productionTime = ({templateOptions}) => chain(
    templateOptions.options.filter((o) => o.devKey === "bulk_ship_delay_to_ship"),
    (_) => _[0]?.value ?? 0,
);

const Description = ({description}) => DivCollapser1({
    expandedBottomPadding: 25,
    collapsedHeight: 48,
    className: "description",
    renderContent: (ref) => (
        <div className="text" ref={ref}>
            {description}
        </div>
    )
});

const FinishedSize = ({product}) => product && (
    <div className="sizes">
        {product.finishedWidth != 0 && product.finishedHeight != 0 && (
            <div className="finished-size">
                <div className="label">Finished Size:</div>
                <div className="value">{product.finishedWidth}{`"` }{" x "}{product.finishedHeight}{`"`}</div>
            </div>
        )}

        {(
            (product.finishedWidth != 0 && product.finishedHeight != 0) &&
            (product.flatWidth != product.finishedWidth || product.flatHeight != product.finishedHeight )
        ) && (
            <div className="finished-size">
                <div className="label">Flat Size:</div>
                <div className="value">{product.flatWidth}{`"` }{" x "}{product.flatHeight}{`"`}</div>
            </div>
        )}
    </div>
);

const uyoHelperSection = () => cs(
    consumeContext("systemConstants"),
    ({systemConstants}) => (
        <div className="uyo-helper-section">
            <div xd-qa-type="label" xd-qa-name="Your artwork should contain all pages of the brochure in one PDF file.">
                Your artwork should contain all pages of the brochure in one PDF file.
            </div>
            <div xd-qa-type="label" xd-qa-name="File size Message">
                Maximum file size for your artwork is {parseInt(systemConstants?.value?.UPLOAD_MAX_CHUNKED_UPLOAD) / 1000000} MB.
            </div>
            <div className="uyo-guide-message">Review our <a
                className="link"
                xd-qa-type="link"
                xd-qa-name="UYO guidelines"
                href="https://assets.xpressdocs.com/next_images/help_downloads/UYO_Template_Design_Guide.pdf"
                target="_blank"
            >
                UYO Guidelines
            </a> for more information.</div>
        </div>
    )
)

const ProductionTime = ({time}) => (
    <div className="production-time">
        <div className="label">
            Ships in
        </div>
        <div className="value">
            {time}{" - "}{(Number(time)+3)}{" "}business days
        </div>
    </div>
);

const AvailableStock = ({stock}) => (
    <div className="production-time">
        <div className="label">
            Available Quantity:
        </div>
        <div className="value">
            {stock}
        </div>
    </div>
);

const VariationsAvailableStock = ({allowBackOrder, availableQuantity}) => (
    <div className="production-time">
        <div className="label">
            Availability
        </div>
        <div className="value">
            {
                availableQuantity < 0
                ? "This item is available for order"
                : (
                    availableQuantity === 0
                    ? `Out of stock. ${allowBackOrder ? "This product is available for backorder." : ""}`
                    : `${availableQuantity} units`
                )
            }
        </div>
    </div>
);

